import { CatalogService } from './CatalogService';

export class CashRegisterService extends CatalogService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
}
// import {AppServices} from "../../config/entities";

// export class CashRegisterService {
//     constructor(private catalogName: string) {
//         this.catalogName = catalogName;
//     }

//     async GetAll(searchText: string | undefined) {
//         console.log(`GetAll ${this.catalogName}`, searchText);
//         let url = this.catalogName;
//         if (searchText) {
//             url += "?searchText=" + searchText;
//         }

//         const response = await AppServices.Axios.get(url);
//         return response.data;
//     }

//     async Get(id: string) {
//         console.log(`Get ${this.catalogName}`, id);
//         const response = await AppServices.Axios.get(this.catalogName + "/" + id);
//         return response.data;
//     }

//     async Delete(selectedItemId: string | null) {
//         if (selectedItemId) {
//             console.log("Delete", selectedItemId);
//             const response = await AppServices.Axios.delete(this.catalogName + "/" + selectedItemId);
//             console.log("Delete response", response);
//         }
//     }

//     async Update(model: any) {
//         console.log("Update", model);
//         const response = await AppServices.Axios.put(this.catalogName, model);
//         console.log("Update response", response);
//     }

//     async Create(model: any) {
//         console.log("Create", model);
//         const response = await AppServices.Axios.post(this.catalogName, model);
//         console.log("Create response", response);
//     }
// }